import { ref, watch, onUnmounted } from 'vue'
import { useJobStore } from '@/stores/job'

export function useJobDuration(jobRef) {
  const jobStore = useJobStore()
  const duration = ref('00:00:00')
  let intervalId = null

  const stopTimer = () => {
    if (intervalId) {
      clearInterval(intervalId)
      intervalId = null
    }
  }

  watch(
    jobRef,
    (newJob) => {
      stopTimer()

      if (newJob && newJob.visits) {
        const isAnyVisitInProgress = newJob.visits.some((v) => v.status === 'בתהליך')

        duration.value = jobStore.getJobTotalActualDuration(newJob)

        if (isAnyVisitInProgress) {
          intervalId = setInterval(() => {
            duration.value = jobStore.getJobTotalActualDuration(newJob)
          }, 1000)
        }
      } else {
        duration.value = '00:00:00'
      }
    },
    { immediate: true, deep: true }
  )

  onUnmounted(stopTimer)

  return { duration }
}
